// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2aMfD","checkboxCol":"Table_checkboxCol__2u87G","emailCol":"Table_emailCol__2IOw3","actionCol":"Table_actionCol__kagmK"};